<span class="icc-checkbox-layout">
    <span class="icc-checkbox-inner-container"
    [class.icc-checkbox-inner-container-no-side-margin]="!checkboxLabel.textContent || !checkboxLabel.textContent.trim()"
    >
        <span class="icc-checkbox-background">
            <icc-icon class="icc-checkbox-done" name="done"></icc-icon>
            <icc-icon class="icc-checkbox-nomark" name="disabled"></icc-icon>
            <icc-icon class="icc-checkbox-mixedmark" name="alternative"></icc-icon>
        </span>
    </span>
    <span class="icc-checkbox-label" #checkboxLabel (cdkObserveContent)="_onLabelTextChange()">
        <!-- Add an invisible span so JAWS can read the label -->
        <span style="display:none">&nbsp;</span>
        <ng-content></ng-content>
    </span>
</span>